export const calculatePosition = (start: number, end: number, time: number) => {
  const totalDuration = end - start
  return ((time - start) / totalDuration) * 100
}
